import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRadium } from 'higher-order-components'
import { Heading } from 'containers'
import { Button, Loading } from 'components'
import shortenUrl from 'apis/short-url'
import { IS_IOS } from '../../constants/environment'

class MobileShare extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      smsHref: false
    }
    const myUrl = this.props.url || window.location.href
    shortenUrl(myUrl).then((response) => {
      const link = response.success ? response.data : window.location.href // use regular url if short url fails
      const smsMessage = `Check out the ${this.props.model} I built: ${link}`
      const smsHref = `sms:${IS_IOS ? '&' : '?'}body=${smsMessage}` // may need to change based on ios or android
      this.setState({ smsHref })
    })
  }
  render() {
    const { model, imageSrc } = this.props

    return (
      <div>
        <Heading value="SHARE" textAlign="center" />
        <div style={{ textAlign: 'center' }}>{model}</div>
        <img style={{ width: '100%' }} src={imageSrc} />
        <Button
          onClick={this.props.EmailShareFunc}
          styleName="blackOutlined"
          label="via email"
          display="block">
          Via Email
        </Button>

        {this.state.smsHref ?
          <Button type="a" href={this.state.smsHref} styleName="blackOutlined" label="via sms" display="block">
            Via SMS
          </Button>
          :
          <Loading />
        }
      </div>
    )
  }
}

MobileShare.propTypes = {
  model: PropTypes.string,
  imageSrc: PropTypes.string,
  url: PropTypes.string
}

export default withRadium()(MobileShare)



// WEBPACK FOOTER //
// ./src/containers/mobile-share/index.js